module.exports = __webpack_public_path__ + "static/media/alcon1.53672779.png";